var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatetime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pbmayqezha",
    d: "M10.656 10.482L7.334 8.666V3.991h1.333v3.914l2.667 1.428-.678 1.149zM8 1.333C4.318 1.333 1.334 4.318 1.334 8S4.31 14.666 8 14.666c3.682 0 6.667-2.984 6.667-6.666 0-3.682-2.985-6.667-6.667-6.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-173 -855) translate(105 119) translate(24 728) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173 -855) translate(105 119) translate(24 728) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.444 12.444)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c8uhk5vnub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pbmayqezha"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#323232",
    xlinkHref: "#pbmayqezha"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#c8uhk5vnub)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.074 13.422h-1.58v1.6h1.58v-1.6zm3.16 0h-1.58v1.6h1.58v-1.6zm3.161 0h-1.58v1.6h1.58v-1.6zm1.58-5.6h-.79v-1.6h-1.58v1.6H9.284v-1.6h-1.58v1.6h-.79c-.877 0-1.573.72-1.573 1.6l-.008 11.2c0 .88.704 1.6 1.58 1.6h11.062c.87 0 1.58-.72 1.58-1.6v-11.2c0-.88-.71-1.6-1.58-1.6zm0 12.8H6.914v-8.8h11.061v8.8z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetime);
export default __webpack_public_path__ + "static/media/datetime.900c0a8647edd377ea08dd139cc42f5e.svg";
export { ForwardRef as ReactComponent };